import React from 'react';
import * as Icons from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { whyChooseUs } from '../../mock';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Reveal, Stagger, StaggerItem } from '../motion/Reveal';

export const WhyChooseUs = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 bg-[#1a1a1a]">
      <div className="container mx-auto px-5 md:px-10">
        <Reveal className="text-center mb-16">
          <h2 className="heading-4 gradient-text-primary">
            {t({ sl: 'ZAKAJ IZBRATI MATRIX PRINT?', en: 'WHY CHOOSE MATRIX PRINT?', it: 'PERCHÉ SCEGLIERE MATRIX PRINT?' })}
          </h2>
        </Reveal>
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="why-choose-us-grid">
          {whyChooseUs.map((item) => {
            const IconComponent = Icons[item.icon];
            return (
              <StaggerItem key={item.icon} className="h-full">
                <Card className="team-card bg-transparent border-[rgba(255, 255, 255, 0.1)] text-center h-full">
                  <CardHeader>
                    <div className="mx-auto w-16 h-16 rounded-full bg-[white] flex items-center justify-center mb-4">
                      <IconComponent className="w-8 h-8 text-[#000000]" />
                    </div>
                    <CardTitle className="text-[white] text-xl">{t(item.title)}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-[#b0b0b0] body-small">{t(item.description)}</p>
                  </CardContent>
                </Card>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
